<script>
    import AppComponent from "./AppComponent.svelte";
    import {store} from './Utils/stores.js';
    import {isOffline} from "./services/configService";

    function header_image(product_name) {
        return `./resources/images/header_banner.jpg`;
    }

</script>
<div id="bannerlogoshoutout" class="container-fluid position-relative">
    <div class="center-items">
        <div class="">
            <div class="vec-w-full vec-relative vec-h-[200px] md:vec-h-[360px] vec-flex vev-flex-col items-center vec-justify-center">
                <img id="product-page-logo" src={header_image($store.product)} alt=""
                     class="vec-object-cover"/>
                <div>
                    <div class="vec-absolute vec-p-5 md:vec-p-24 vec-left-0 vec-right-0 vec-top-0 vec-flex vec-flex-col vec-justify-center vec-w-full vec-h-full z-10">
                        <h1 class="vec-text-darkerGrey vec-text-4xl vec-font-semibold">
                            {#if $store.machinable_only}
                                Trial Machinable Tutorials
                            {:else}
                                Training Videos
                            {/if}
                        </h1>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div>
    <AppComponent/>
</div>

